export const BoundingBoxTypes = {
  default: "DEFAULT",
  instance_segmentation: "INSTANCE_SEGMENTATION"
}

export const BoundingBoxProperties = {
  bounding_box: "bounding_box",
  instance_segment: "instance_segment"
}
